import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Header from '../components/Secciones/Header';
import Footer from '../components/Secciones/Footer';
import { verifyEmailToken } from '../utils/accountApi';
import './VerifyEmail.css';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fragmentParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const token = fragmentParams.get('token') || searchParams.get('token');
    // Only a loose sanity check here (present, no whitespace, reasonable
    // length) -- the backend is the source of truth for whether a token is
    // actually valid. A strict client-side format check risks rejecting
    // legitimate tokens outright if the backend's token format ever changes.
    if (!token || token.trim().length < 16 || /\s/.test(token)) {
      setStatus('error');
      setMessage('Invalid or expired token.');
      return;
    }

    window.history.replaceState(null, document.title, window.location.pathname);

    const controller = new AbortController();
    let redirectTimer;

    const verify = async () => {
      try {
        await verifyEmailToken(token, { signal: controller.signal });
        setStatus('success');
        setMessage('Email successfully verified! ✅ You will be redirected to the home page in 10 seconds.');
        redirectTimer = setTimeout(() => navigate('/'), 10000);
      } catch (error) {
        if (error.name === 'AbortError') return;
        setStatus('error');
        setMessage(error.message || 'The email could not be verified.');
      }
    };

    verify();

    return () => {
      controller.abort();
      if (redirectTimer) clearTimeout(redirectTimer);
    };
  }, [searchParams, navigate]);

  return (
    <div>
        <Header />
        <div className="ve-verify-email-container">
        {status === 'verifying' && <h2>Verifying your email...</h2>}
        {status === 'success' && (
        <>
          <h2 className="ve-success">{message}</h2>
          <a href="/">Go back to Home now</a>
        </>
      )}
      {status === 'error' && <h2 className="ve-error">{message}</h2>}
        </div>
        <Footer />
    </div>
  );
};

export default VerifyEmail;
